(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('Dinghy', Dinghy);

    Dinghy.$inject = ['$resource', 'DateUtils'];

    function Dinghy ($resource, DateUtils) {
        var resourceUrl =  'api/dinghies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateDeactivated = DateUtils.convertLocalDateFromServer(data.dateDeactivated);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateDeactivated = DateUtils.convertLocalDateToServer(copy.dateDeactivated);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateDeactivated = DateUtils.convertLocalDateToServer(copy.dateDeactivated);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
